import React from 'react';
import dayjs from 'dayjs';
import moment from 'moment';
import { Popconfirm, Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEdit } from '@fortawesome/free-solid-svg-icons';

import styles from './Firmwares.module.less';

const relativeTime = require('dayjs/plugin/relativeTime');

dayjs.extend(relativeTime);

const commonColumns = (t) => [
  {
    title: t('tables.portales.columns.date_created'),
    width: '22.5%',
    dataIndex: 'created_at',
    fixed: 'left',
    sorter: true,
    // eslint-disable-next-line react/jsx-filename-extension
    render: (e, data) => (<div>{moment(e).subtract(5, 'hours').format('YYYY-MM-DD HH:MM')}</div>),
  },
  {
    title: t('forms.users.labels.business_line'),
    width: '11%',
    dataIndex: 'business_type_name',
    fixed: 'left',
    sorter: true,
  },
  {
    width: '22.5%',
    title: t('tables.firmwares.columns.version'),
    dataIndex: 'version',
    render: (name) => name || '-',
  },
  {
    width: '22.5%',
    title: t('tables.firmwares.columns.fw_url'),
    dataIndex: 'fw_url',
    render: (client) => client || '-',
  },
  {
    title: t('tables.firmwares.columns.fw_crc'),
    width: '22.5%',
    dataIndex: 'fw_crc',
    render: (firmware) => firmware || '-',
  },
];

const columnsFirmwares = (t, deleteFirmware, currentUser, editFirmware) => {

  const isAdmin = currentUser.role === 'Superadmin' || currentUser.role === 'Admin';

  const columns = commonColumns(t);

  if (isAdmin) {

    columns.push(
      {
        key: 'has_missing_data_alarm_rule',
        width: '10%',
        title: '',
        dataIndex: 'id',
        render: (_, record) => ( // edit users
          // eslint-disable-next-line react/jsx-filename-extension
          <Space>
            <div className={styles.btnsIcon} style={{ marginRight: 5 }}>
              <FontAwesomeIcon icon={faEdit} onClick={() => editFirmware(record)} />
            </div>

            <div className={styles.btnsIcon} style={{ marginLeft: 5 }}>
              <Popconfirm
                title={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_title')}
                okText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_ok')}
                cancelText={t('views.dynamic_alarms.feedbacks.delete_alarms.confirm_cancel')}
                onConfirm={() => deleteFirmware(record)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </Popconfirm>
            </div>
          </Space>
        ),
      },

    );

}

  return columns;

};

export default columnsFirmwares;
